import React from 'react'
import {Col, Badge, Label} from 'reactstrap'
import {Link} from 'react-router-dom'
import Loader from 'react-loader-spinner'
import {ModelListTable} from '../../ui'
import {getAllTeams, WS_URL} from '../../../api'
import Websocket from "react-websocket"

import {Team, AppError} from "../../../models"
import {pageHelpers} from "../"
import CustomerTeamIcon from "react-icons/lib/fa/group"
import ManageTeamIcon from "react-icons/lib/fa/wrench"
import ControllerIcon from "react-icons/lib/fa/square"

import '../../../stylesheets/Search.css'

const MANAGE_TEAM_FIELD_NAME = "-"
const VIEW_CONTROLLERS_FIELD_NAME = "_"

let manageTeamLinkGenerator = (team) => {
    return <Link to={`/teams/${team.id}`}>
        <Badge className="p-2 bg-light-sf-blue">
            <ManageTeamIcon className="d-none d-md-inline-block mr-2"/>
            <span className="d-inline-block d-md-none">MNG</span>
            <span className="d-none d-md-inline-block">Manage</span>
        </Badge>
    </Link>
}

let viewControllersLinkGenerator = (team) => {
    return <Link to={`/teams/${team.id}/controllers`}>
        <Badge className="p-2 bg-sf-orange">
            <ControllerIcon className="d-none d-md-inline-block mr-2"/>
            <span className="d-inline-block d-md-none">CONS</span>
            <span className="d-none d-md-inline-block">Controllers</span>
        </Badge>
    </Link>
}

class SearchPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        const {token} = props

        this.state = {
            token,
            loading: false,
            errors: [],
            teams: [],
        }

        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.fetchTeams = this.fetchTeams.bind(this)
    }

    async componentWillReceiveProps(nextProps) {
        const {token} = nextProps
        pageHelpers.setupPropsForPage(nextProps, this)
        if (token) {
            await this.setState({token, loading: true})
            await this.fetchTeams()
            this.setState({loading: false})
        }
    }

    async componentDidMount() {
        if (this.state.token) {
            this.setState({loading: true})
            await this.fetchTeams()
            this.setState({loading: false})
        }
    }


    async fetchTeams() {
        let {token} = this.state
        try {
            let {results} = await getAllTeams(token, true, true, true, false, 1, 100000)
            this.setState({teams:results})
        } catch(err) {
            console.log(err)
            let appError = new AppError("Failed to Get Teams", err.message)
            this.setState({errors:[appError]})
        }
    }

    handleWebSocketResponse(data) {
        let result = JSON.parse(data)
        let updatedTeam = Team.fromAPIObject(result)
        let {teams} = this.state
        let filteredTeams = teams.filter((t) => t.id !== updatedTeam.id)
        if (filteredTeams.length < teams.length) {
            teams = filteredTeams
            teams.push(updatedTeam)
            this.setState({teams})
        }
    }

    render() {
        let {errors, token, teams, loading} = this.state

        let fixedCharacterWidthFields = {dealer: 6.0, cons: 4.9, users: 5.1}
        fixedCharacterWidthFields[MANAGE_TEAM_FIELD_NAME] = [4.2, 8]
        fixedCharacterWidthFields[VIEW_CONTROLLERS_FIELD_NAME] = [4.2, 8]
        let fieldContentGenerators = {}
        fieldContentGenerators[MANAGE_TEAM_FIELD_NAME] = manageTeamLinkGenerator
        fieldContentGenerators[VIEW_CONTROLLERS_FIELD_NAME] = viewControllersLinkGenerator

        let count = (teams && teams.length ? teams.length : 0)
        let customerCount = (teams && teams.length ? teams.filter(t=>!t.dealership).length : 0)
        let dealerCount = (teams && teams.length ? teams.filter(t=>t.dealership).length : 0)

        return (
            <Col xs={12} className="text-center">
                <h1 className="col-12 no-gutters mb-2 d-block d-sm-none light-sf-orange font-weight-bold p-0"><CustomerTeamIcon
                    className="light-sf-blue mr-2"/>Search Teams</h1>
                <h1 className="col-12 no-gutters mb-2 d-none d-sm-block light-sf-orange font-weight-bold"><CustomerTeamIcon
                    className="light-sf-blue mr-2"/>Search All Teams</h1>
                <p className="col-12 col-md-auto mb-1 mb-md-4 d-inline-block p-0 mr-0 ml-0">
                    <Link className="light-sf-blue" to="/management/teams/provision/customer">Create a new Customer Team</Link>
                    <span className="d-none d-md-inline-block m-2">&mdash;</span>
                </p>
                <p className="col-12 col-md-auto mb-4 d-inline-block p-0 mr-0 ml-0">
                    <Link className="light-sf-blue" to="/management/teams/provision/dealer">Create a new Dealer Team</Link>
                </p>

                {count && !loading ?
                    <Label className="small text-secondary col-12 text-left">
                        {count} Teams &mdash; {customerCount} Customer Teams &mdash; {dealerCount} Dealer Teams
                    </Label>:
                        null}

                {loading ?
                    <Col xs={12} className="text-center m-4">
                        <Loader type="TailSpin" color="orange" width={60} height={60}/>
                    </Col> :
                    <ModelListTable models={teams}
                                    fields={["dealer", "name", "users", "cons", MANAGE_TEAM_FIELD_NAME, VIEW_CONTROLLERS_FIELD_NAME]}
                                    searchFields={["name",]}
                                    boldFields={["name"]}
                                    hideableFields={["dealer", "users", "cons",]}
                                    leftAlignFields={["name", ]}
                                    fixedCharacterWidthFields={fixedCharacterWidthFields}
                                    fieldContentGenerators={fieldContentGenerators}
                                    className="p-0"/>}

                {token && teams && !loading ?
                    teams.map((t, idx) =>
                        <Websocket key={`ws-${t.id}-${idx}`}
                                    url={`${WS_URL}/teams/${t.id}/?access_token=${token.accessToken}`}
                                   onMessage={this.handleWebSocketResponse}/>
                    ):
                        null}

                {pageHelpers.renderErrorModalsForPage(errors, this)}
            </Col>)
    }
}

export default SearchPage



// WEBPACK FOOTER //
// ./src/components/pages/teams/SearchPage.js